<template>
  <div class="riclothes-licence-viewer">
    <RiClothesText class="riclothes-licence-viewer--title" :class="{ [`full-mode--title`]: isFullMode }">{{ basicTitleText }}</RiClothesText>
    <div v-if="!isEnglish">
      <div v-for="licenceContent in basic" :key="licenceContent.text" >
        <RiClothesText class="riclothes-licence-viewer--text" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text" v-for="(detail, detailIndex) in licenceContent.detail" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>
    <div v-if="isEnglish">
      <div v-for="licenceContent in basic" :key="licenceContent.text_en" >
        <RiClothesText class="riclothes-licence-viewer--text" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text_en }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text" v-for="(detail, detailIndex) in licenceContent.detail_en" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>

    <RiClothesText class="riclothes-licence-viewer--title__other" :class="{ [`full-mode--title`]: isFullMode }" v-if="remarks">{{ remarksTitleText }}</RiClothesText>
    <div v-if="!isEnglish">
      <div v-for="licenceContent in remarks" :key="licenceContent.text">
        <RiClothesText class="riclothes-licence-viewer--text__other" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__other" v-for="(detail, detailIndex) in licenceContent.detail" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>
    <div v-if="isEnglish">
      <div v-for="licenceContent in remarks" :key="licenceContent.text_en">
        <RiClothesText class="riclothes-licence-viewer--text__other" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text_en }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__other" v-for="(detail, detailIndex) in licenceContent.detail_en" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>

    <RiClothesText class="riclothes-licence-viewer--title__do" :class="{ [`full-mode--title`]: isFullMode }">{{ doTitleText }}</RiClothesText>
    <div v-if="!isEnglish">
      <div v-for="licenceContent in licenceDo" :key="licenceContent.text">
        <RiClothesText class="riclothes-licence-viewer--text__do" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__do" v-for="(detail, detailIndex) in licenceContent.detail" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>
    <div v-if="isEnglish">
      <div v-for="licenceContent in licenceDo" :key="licenceContent.text_en">
        <RiClothesText class="riclothes-licence-viewer--text__do" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text_en }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__do" v-for="(detail, detailIndex) in licenceContent.detail_en" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>

    <RiClothesText class="riclothes-licence-viewer--title__do_not" :class="{ [`full-mode--title`]: isFullMode }">{{ doNotTitleText }}</RiClothesText>
    <div v-if="!isEnglish">
      <div v-for="licenceContent in licenceDoNot" :key="licenceContent.text">
        <RiClothesText class="riclothes-licence-viewer--text__do_not" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__do_not" v-for="(detail, detailIndex) in licenceContent.detail" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>
    <div v-if="isEnglish">
      <div v-for="licenceContent in licenceDoNot" :key="licenceContent.text_en">
        <RiClothesText class="riclothes-licence-viewer--text__do_not" :class="{ [`full-mode--text`]: isFullMode }">{{ licenceContent.text_en }}</RiClothesText>
        <RiClothesText class="riclothes-licence-viewer--detail_text__do_not" v-for="(detail, detailIndex) in licenceContent.detail_en" :key="detailIndex" :class="{ [`full-mode--detail`]: isFullMode }">{{ detail }}</RiClothesText>
      </div>
    </div>
  </div>
</template>

<script>
import RiClothesText from "../components/RiClothesText";

export default {
  name: "ri-clothes-licence-viewer",
  components: {
    RiClothesText
  },
  props: {
    basic: {
      basic: Array,
      default: () => { return [
        {
          text: "ベースとなるアバターの利用規約 / ライセンスにも必ず従う必要があります",
          text_en: "You must also follow the terms of use / licence of the underlying avatar"
        },
        {
          text: "商品 / 配布物 に特記事項がある場合、特記事項の内容が優先されます",
          text_en: "If a products/distributions has remarks, the remarks will take precedence"
        },
        {
          text: "特別に許可が得られた場合は、許可が得られた内容が優先されます",
          text_en: "Where special permission has been granted, the permission granted will take precedence"
        },
        {
          text: "起きた損害などに対する保証などは一切ございません",
          text_en: "There is no warranty for any damage that may occur"
        },
        {
          text: "英語版はあくまで参考として翻訳されたものであり、常に日本語版が適用されます",
          text_en: "English version has been translated for reference only and the Japanese version will always apply."
        }
      ] }
    },
    licenceDo: {
      licenceDo: Array,
      default: () => { return [
        {
          text: "改変/パーツ取り",
          text_en: "Modifying / Pick up parts"
        },
        {
          text: "R-18 使用",
          text_en: "Use R-18"
        },
        {
          text: "R-18G 使用",
          text_en: "Use R-18G"
        },
        {
          text: "商用利用",
          text_en: "Commercial use",
          detail: [
            "個人: 特に制限はございません",
            "法人: 購入ページ / 配布ページのURLをどこかに記載してください"
          ],
          detail_en: [
            "Personal: There are no restrictions",
            "Corporation: Please include the URL of the purchase page/distribution page somewhere"
          ]
        }
      ]}
    },
    licenceDoNot: {
      licenceDoNot: Array,
      default:() => { return [
        {
          text: "購入者様以外が使用できるようにすること",
          text_en: "Make it available to non-purchasers",
          detail: [
            "VRChatにPublic状態でアップロード",
            "VRChatのアバターペデスタルに登録",
            "再配布",
            "など"
          ],
          detail_en: [
            "Uploading avatar to VRChat on public status",
            "Register avatar pedestal in VRChat",
            "Redistribution",
            "etc"
          ]
        },
        {
          text: "政治利用",
          text_en: "Political use"
        },
        {
          text: "中傷目的での利用",
          text_en: "Use for the purpose of defamation"
        }
      ]}
    },
    remarks: Array,
    isFullMode: {
      isFullMode: Boolean,
      default: false
    },
    isEnglish: {
      isEnglish: Boolean,
      default: false
    }
  },
  computed: {
    basicTitleText() {
      if(this.isEnglish) {
        return "Basic";
      } else {
        return "基本事項";
      }
    },
    doTitleText() {
      if(this.isEnglish) {
        return "Do";
      } else {
        return "できること";
      }
    },
    doNotTitleText() {
      if(this.isEnglish) {
        return "Do not";
      } else {
        return "できないこと";
      }
    },
    remarksTitleText() {
      if(this.isEnglish) {
        return "Remarks";
      } else {
        return "特記事項";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.riclothes-licence-viewer {
  &--title {
    display: block;
    color: var(--color-blue);
    border-bottom: 2px solid var(--color-blue);
    max-width: 240px;
    font-size: 1.2rem;
    margin-bottom: 4px;
    &::before {
      content: "・";
    }

    &__do {
      @extend .riclothes-licence-viewer--title;
      color: var(--color-green);
      border-color: var(--color-green);
    }
    &__do_not {
      @extend .riclothes-licence-viewer--title;
      color: var(--color-red);
      border-color: var(--color-red);
    }
    &__other {
      @extend .riclothes-licence-viewer--title;
      color: var(--color-purple);
      border-color: var(--color-purple);
    }
  }

  &--text {
    &::before {
      content: "・";
      color: var(--color-blue);
    }

    &__do {
      @extend .riclothes-licence-viewer--text;
      &::before {
        color: var(--color-green);
      }
    }
    &__do_not {
      @extend .riclothes-licence-viewer--text;
      &::before {
        color: var(--color-red);
      }
    }
    &__other {
      @extend .riclothes-licence-viewer--text;
      &::before {
        color: var(--color-purple);
      }
    }
  }

  &--detail_text {
    margin-left: 1.2rem;
    padding-left: 0.4rem;
    border-left: 2px solid var(--color-blue);
    &::before {
      content: "∘ ";
      color: var(--color-blue);
    }

    &__do {
      @extend .riclothes-licence-viewer--detail_text;
      border-color: var(--color-green);
      &::before {
        color: var(--color-green);
      }
    }
    &__do_not {
      @extend .riclothes-licence-viewer--detail_text;
      border-color: var(--color-red);
      &::before {
        color: var(--color-red);
      }
    }
    &__other {
      @extend .riclothes-licence-viewer--detail_text;
      border-color: var(--color-purple);
      &::before {
        color: var(--color-purple);
      }
    }
  }
}

.full-mode {
  &--title {
    font-size: 1.6rem !important;
    max-width: 460px;
  }
  &--text {
    font-size: 1.2rem !important;
  }
  &--detail {
    font-size: 1.1rem !important;
  }
}
</style>